
import {Component, Vue} from "vue-property-decorator";
import vanTabs from 'vant/lib/tabs';
import vanTab from 'vant/lib/tab';
import 'vant/lib/tabs/style';
import 'vant/lib/tab/style';

@Component({
    components:{vanTabs,vanTab}
})
export default class HomeClass extends Vue {
    public activeIndex: number = 0;

    public cur: any = 0
    public tabList: any = ['水泥窑预燃炉技术', '泥状废弃物仓储泵送系统', '大件垃圾处置系统', '水泥窑旁路除氯系统']
    public dataList: any = [1, 2, 3, 4, 5, 6]
    public startX: any = null
    public moveX: any = null
    public index: any = 0

    public tabClick(index: number) {
        this.activeIndex = index;
    }

    mounted() {
        console.log(this.$route.query.type);
        window.scrollTo(0, 0);
        const t = this.$route.query.type;

        console.log(t);
        if (t === '3-1') {
            this.cur = 0;
        }

        if (t === '3-2') {
            this.cur = 1;
        }

        if (t === '3-3') {
            this.cur = 2;
        }
        if (t === '3-4') {
            this.cur = 3;
        }

        if (t === '3-5') {
            this.cur = 4;
        }


    }


    changeTab(index: any) {
        this.cur = index;
        this.activeIndex = index;
        this.setMove(index);
    }

}
